import { Navigate, Route, Routes } from 'react-router-dom';
import { RESOURCES } from '@/app/casl/resources';
import AnnouncementListPage from '@/app/pages/notifications/announcements/AnnouncementListPage';
import AnnouncementReportPage from '@/app/pages/notifications/announcements/AnnouncementReportPage';
import { AbilityProtectedRoute } from '@/app/routing/AbilityProtectedRoute';

const AnnouncementWrapper = () => (
  <Routes>
    <Route index element={<AnnouncementListPage />} />
    <Route
      element={
        <AbilityProtectedRoute permission={RESOURCES.PUBLICAR_COMUNICADOS}>
          <AnnouncementReportPage />
        </AbilityProtectedRoute>
      }
      path="relatorio/:id"
    />
    <Route element={<Navigate replace to="/error/404" />} path="*" />
  </Routes>
);

export default AnnouncementWrapper;
